import React, { ReactNode } from 'react';
import { FileType, ProjectType } from 'nekst-api';
import useDefaultPortalConfigurationService, {
  DefaultPortalConfiguration
} from './defaultPortalConfigurationService';
import useDataLoader from 'data-loader';
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  CheckboxInput,
  FormTemplate,
  LoadingAnimation,
  SubmitButton
} from 'ui-builder';
import DetailBoxesCheckboxGroup from './DetailBoxesCheckboxGroup';
import { Separator } from 'features/nekst-widgets';
import ServiceProvidersGroupSelector, {
} from '../../../projects/clientportal/ServiceProvidersGroupSelector';
import ServiceProvidersContext from '../../../projects/clientportal/ServiceProvidersContext';
import DocumentLabelsCheckboxGroup from './DocumentLabelsCheckboxGroup';
import PortalTitleInput from './PortalTitleInput';
import { createPortal } from 'react-dom';
import InstantImageUploaderInput
  from '../../../shared/uibuilder/form/input/InstantImageUploaderInput';
import { CopyConfigurationWidget } from './CopyConfigurationWidget';
import { FormType, useFormMapper } from './defaultPortalConfigurationFormMapper';

export function ConfigurationFormButtonPortal() {
  return (<div id="portal-configuration-form-button-portal" />)
}

function ConfigurationFormButtonPortalWrapper(
  props: {
    children: ReactNode,
  }
) {
  const container = document.getElementById('portal-configuration-form-button-portal');

  if (container) {
    return createPortal(props.children, container);
  } else {
    return props.children;
  }

}


export default function PortalConfigurationForm(props: {
  projectType: ProjectType
  setupAreaId?: string | number
}) {
  const [portalConfiguration, setPortalConfiguration] = React.useState<DefaultPortalConfiguration>();

  const service = useDefaultPortalConfigurationService();

  const formMapper = useFormMapper();

  useDataLoader(
    async () => {
      setPortalConfiguration(undefined);
      return await service.getPortalConfiguration(props.projectType, props.setupAreaId);
    },
    setPortalConfiguration,
    props.projectType,
    props.setupAreaId
  );

  if (portalConfiguration) {
    return (
      <ServiceProvidersContext>
        <FormTemplate<FormType>
          submitFormFunc={async (data) => {
            const result = await service.updatePortalConfiguration(
              props.projectType,
              formMapper.toApiView(data),
              props.setupAreaId,
            );

            return formMapper.toFormView(result);
          }}
          initialData={formMapper.toFormView(portalConfiguration)}
          buttons={(
            <ConfigurationFormButtonPortalWrapper>
              <SubmitButton text="Save" color={ButtonColor.BLUE} variant={ButtonVariant.FILLED} size={ButtonSize.MEDIUM} />
            </ConfigurationFormButtonPortalWrapper>
          )}
        >
          <CopyConfigurationWidget projectType={props.projectType} />
          <CheckboxInput source="isEnabled" label="Client Portal Enabled" />
          <PortalTitleInput source="title" label="Title" projectType={props.projectType} />
          <InstantImageUploaderInput
            source="photoId"
            previewSource="_photo"
            label="Transaction Photo"
            fileType={FileType.PROJECT_PHOTO}
            hint="Please ensure that the uploaded file has a minimum width of 1000 pixels and a minimum height of 450 pixels."
          />
          <DetailBoxesCheckboxGroup
            projectType={props.projectType}
            setupAreaId={props.setupAreaId}
            label="Detail Boxes"
            source="detailsFieldsIds"
          />
          <Separator />
          <div>Contacts to display</div>
          <CheckboxInput source="showAllTransactionParties" label="Add All Contacts By Default" />
          <Separator />
          <DocumentLabelsCheckboxGroup source="documentLabelsIds" label="Documents To Include" />
          <ServiceProvidersGroupSelector
            source="serviceProvidersLinks"
            label="Additional Service Providers To Include"
          />
        </FormTemplate>
      </ServiceProvidersContext>

    );
  } else {
    return (<LoadingAnimation />);
  }

}
